
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logistics-software-development-services",
      function () {
        return require("private-next-pages/logistics-software-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logistics-software-development-services"])
      });
    }
  